import { render, staticRenderFns } from "./SettingsNetworkNew.vue?vue&type=template&id=3d55d254"
import script from "./SettingsNetworkNew.vue?vue&type=script&lang=js"
export * from "./SettingsNetworkNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports